import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import { useTheme } from '@emotion/react';
import { KeyboardArrowRight, Remove, Add, Done, Lens } from 'emotion-icons/material';
import * as React from 'react';
import { ListItem as ListItem$2 } from './List.styles.js';

var _excluded = ["children", "content", "icon", "inPackageCard", "listIcon"];
var ListItem = function ListItem(_ref) {
  var _components$PackageCa;
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$content = _ref.content,
    content = _ref$content === void 0 ? null : _ref$content,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? /*#__PURE__*/React.createElement(Lens, {
      size: "0.5em",
      style: {
        marginTop: '0.45em'
      }
    }) : _ref$icon,
    _ref$inPackageCard = _ref.inPackageCard,
    inPackageCard = _ref$inPackageCard === void 0 ? false : _ref$inPackageCard,
    _ref$listIcon = _ref.listIcon,
    listIcon = _ref$listIcon === void 0 ? null : _ref$listIcon,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useTheme = useTheme(),
    components = _useTheme.components;
  var renderedIcon = listIcon;
  if (!listIcon) {
    var _components$ListItem;
    switch (components === null || components === void 0 || (_components$ListItem = components.ListItem) === null || _components$ListItem === void 0 ? void 0 : _components$ListItem.icon) {
      case 'Lens':
        renderedIcon = icon;
        break;
      case 'Done':
        renderedIcon = /*#__PURE__*/React.createElement(Done, null);
        break;
      case 'Add':
        renderedIcon = /*#__PURE__*/React.createElement(Add, null);
        break;
      case 'Remove':
        renderedIcon = /*#__PURE__*/React.createElement(Remove, null);
        break;
      case 'KeyboardArrowRight':
        renderedIcon = /*#__PURE__*/React.createElement(KeyboardArrowRight, null);
        break;
      default:
        renderedIcon = icon;
        break;
    }
  }
  if (inPackageCard && components !== null && components !== void 0 && (_components$PackageCa = components.PackageCard) !== null && _components$PackageCa !== void 0 && _components$PackageCa.hideIcons) {
    renderedIcon = null;
  }
  return /*#__PURE__*/React.createElement(ListItem$2, _extends({
    className: "leshen-list-item",
    icon: renderedIcon && true
  }, props), renderedIcon && renderedIcon, content && /*#__PURE__*/React.createElement("div", null, content), children && /*#__PURE__*/React.createElement("div", null, children));
};
var ListItem$1 = ListItem;

export { ListItem$1 as default };
//# sourceMappingURL=ListItem.js.map
